<template>
  <div v-if="retribution" class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <StackedField label="Prime vendeur" :value="formatPrice(retribution.sellerAmount)" />
      <StackedField label="Prime manager" :value="formatPrice(retribution.managerAmount)" />
      <StackedField label="Date de création" :value="retribution.creationDate" />
      <StackedField
        v-if="retribution.retributionsPayoutMethod"
        label="Type de versement"
        :value="$t(`retributions.retributions_payout_method.${retribution.retributionsPayoutMethod}`)"
      />
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";

export default {
  components: {
    StackedField,
  },
  props: ["retribution"],
  methods: {
    formatPrice,
  },
};
</script>
